import React from 'react';
import { StyledCheckBox } from './styled';

const BaseCheckBox = ({ ...props }) => {
  return <StyledCheckBox {...props} />;
};

export default BaseCheckBox;
